//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const URL = import.meta.env.VITE_DRIVER_TRIPS_API || `${window.location.origin}/trips`;

export class TelematicsDriverTripsClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Retrieves a paginated list of trip summaries for a specific policy, ordered by most recent first.
	 * @param policyReference (optional) The unique policy reference number (e.g., HAVPC00000001). Must belong to the authenticated customer.
	 * @param pageNumber (optional) The 1-based page number to retrieve. Defaults to 1 (first page).
	 * @param pageSize (optional) Number of trip records per page. Minimum: 1, Maximum: 100, Default: 20.
	 * @return Successfully retrieved the paginated trip list. May return an empty list if no trips exist.
	 */
	trips(
		policyReference: string | undefined,
		pageNumber: number | undefined,
		pageSize: number | undefined,
		cancelToken?: CancelToken,
	): Promise<TripSummaryDtoPaginatedList> {
		let url_ = this.baseUrl + '/api/v1/Trips?';
		if (policyReference === null) throw new globalThis.Error("The parameter 'policyReference' cannot be null.");
		else if (policyReference !== undefined) url_ += 'policyReference=' + encodeURIComponent('' + policyReference) + '&';
		if (pageNumber === null) throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
		else if (pageNumber !== undefined) url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
		if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
		else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTrips(_response);
			});
	}

	protected processTrips(response: AxiosResponse): Promise<TripSummaryDtoPaginatedList> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<TripSummaryDtoPaginatedList>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'The policy reference is invalid, or pagination parameters are out of range.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<TripSummaryDtoPaginatedList>(null as any);
	}

	/**
	 * Retrieves comprehensive details for a specific trip, including route data and driving events.
	 * @param tripId The unique GUID identifier of the trip to retrieve. Obtained from the trips list endpoint.
	 * @param policyReference (optional) The policy reference for ownership verification. Must match the trip's associated policy.
	 * @return Successfully retrieved the full trip details.
	 */
	trips2(tripId: string, policyReference: string | undefined, cancelToken?: CancelToken): Promise<TripDetailsDto> {
		let url_ = this.baseUrl + '/api/v1/Trips/{tripId}?';
		if (tripId === undefined || tripId === null) throw new globalThis.Error("The parameter 'tripId' must be defined.");
		url_ = url_.replace('{tripId}', encodeURIComponent('' + tripId));
		if (policyReference === null) throw new globalThis.Error("The parameter 'policyReference' cannot be null.");
		else if (policyReference !== undefined) url_ += 'policyReference=' + encodeURIComponent('' + policyReference) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTrips2(_response);
			});
	}

	protected processTrips2(response: AxiosResponse): Promise<TripDetailsDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<TripDetailsDto>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'The trip ID format is invalid or the policy reference is missing.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException(
				'The trip was not found, or it does not belong to the specified policy/customer.',
				status,
				_responseText,
				_headers,
				result404,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<TripDetailsDto>(null as any);
	}

	/**
	 * Retrieves map display data for a specific trip, including sampled GPS points and driving events.
	 * @param tripId The unique GUID identifier of the trip. Obtained from the trips list endpoint.
	 * @param policyReference (optional) The policy reference for ownership verification.
	 * @param pointInterval (optional) Sample every Nth GPS point. Range: 1-100. Default: 5 (every 5th point).
	 * @return Successfully retrieved the trip map data.
	 */
	mapData(
		tripId: string,
		policyReference: string | undefined,
		pointInterval: number | undefined,
		cancelToken?: CancelToken,
	): Promise<TripMapDataDto> {
		let url_ = this.baseUrl + '/api/v1/Trips/{tripId}/map-data?';
		if (tripId === undefined || tripId === null) throw new globalThis.Error("The parameter 'tripId' must be defined.");
		url_ = url_.replace('{tripId}', encodeURIComponent('' + tripId));
		if (policyReference === null) throw new globalThis.Error("The parameter 'policyReference' cannot be null.");
		else if (policyReference !== undefined) url_ += 'policyReference=' + encodeURIComponent('' + policyReference) + '&';
		if (pointInterval === null) throw new globalThis.Error("The parameter 'pointInterval' cannot be null.");
		else if (pointInterval !== undefined) url_ += 'pointInterval=' + encodeURIComponent('' + pointInterval) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMapData(_response);
			});
	}

	protected processMapData(response: AxiosResponse): Promise<TripMapDataDto> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<TripMapDataDto>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException(
				'The trip ID format is invalid, policy reference is missing, or point interval is out of range.',
				status,
				_responseText,
				_headers,
				result400,
			);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException(
				'The JWT token is missing or does not contain a valid customer reference claim.',
				status,
				_responseText,
				_headers,
				result401,
			);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException(
				'The trip was not found, or it does not belong to the specified policy/customer.',
				status,
				_responseText,
				_headers,
				result404,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<TripMapDataDto>(null as any);
	}
}

/** DTO representing a driving event for map display. */
export interface MapEventDto {
	/** Unique identifier for the event. */
	eventId?: string;
	/** Type of event (e.g., HARSH_BRAKING, SPEEDING, HARSH_ACCELERATION). */
	eventType?: string | undefined;
	/** Severity level (LOW, MEDIUM, HIGH, CRITICAL). */
	severity?: string | undefined;
	/** When the event started. */
	startTime?: Date;
	/** Duration of the event in milliseconds. */
	durationMilliseconds?: number;
	/** Latitude coordinate of the event location. */
	latitude?: number | undefined;
	/** Longitude coordinate of the event location. */
	longitude?: number | undefined;
	/** Encoded polyline showing the path during the event (Google Polyline Algorithm format). */
	polyline?: string | undefined;
}

/** DTO representing a single GPS point for map display. */
export interface MapPointDto {
	/** Sequence number of the point within the trip. */
	sequence?: number;
	/** Timestamp when the point was recorded. */
	timestamp?: Date;
	/** Latitude coordinate. */
	latitude?: number;
	/** Longitude coordinate. */
	longitude?: number;
	/** Speed in miles per hour at this point. */
	speedMph?: number;
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

/** DTO representing full trip details. */
export interface TripDetailsDto {
	/** Unique identifier for the trip. */
	tripId?: string;
	/** The policy reference this trip belongs to. */
	policyReference?: string | undefined;
	/** Trip start time in UTC. */
	startTimeUtc?: Date;
	/** Trip end time in UTC. */
	endTimeUtc?: Date;
	/** Total distance traveled in miles. */
	distanceMiles?: number;
	/** Duration of the trip in seconds. */
	durationSeconds?: number;
	/** Start address of the trip. */
	startAddress?: string | undefined;
	/** End address of the trip. */
	endAddress?: string | undefined;
	riskScores?: TripRiskScoresDto;
	metrics?: TripMetricsDto;
	eventCounts?: TripEventCountsDto;
	/** Individual trip events. */
	events?: TripEventDto[] | undefined;
	/** Encoded polyline for the trip route. */
	polyline?: string | undefined;
}

/** DTO representing trip event counts. */
export interface TripEventCountsDto {
	/** Number of harsh acceleration events. */
	harshAcceleration?: number;
	/** Number of harsh braking events. */
	harshBraking?: number;
	/** Number of harsh cornering events. */
	harshCornering?: number;
	/** Number of speeding events. */
	speeding?: number;
	/** Total number of events. */
	total?: number;
}

/** DTO representing an individual trip event with description and polyline. */
export interface TripEventDto {
	/** Unique identifier for the event. */
	eventId?: string;
	/** Type of event (e.g., HARSH_BRAKING, SPEEDING). */
	eventType?: string | undefined;
	/** Severity level (LOW, MEDIUM, HIGH, CRITICAL). */
	severity?: string | undefined;
	/** Customer-facing description of what happened during this event. */
	description?: string | undefined;
	/** Event timestamp in UTC. */
	timestampUtc?: Date;
	/** Duration of the event in milliseconds. */
	durationMilliseconds?: number;
	location?: TripEventLocationDto;
	/** Encoded polyline showing the path during the event (Google Polyline Algorithm format). */
	polyline?: string | undefined;
}

/** DTO representing an event location. */
export interface TripEventLocationDto {
	/** Latitude coordinate. */
	latitude?: number;
	/** Longitude coordinate. */
	longitude?: number;
}

/** DTO representing map data for a trip, optimized for display in apps and websites. */
export interface TripMapDataDto {
	/** Unique identifier for the trip. */
	tripId?: string;
	/** Total number of GPS points in the original trip data. */
	totalPointCount?: number;
	/** Number of points after sampling (reduced for display performance). */
	sampledPointCount?: number;
	/** Sampled GPS points for rendering the trip route on a map. */
	points?: MapPointDto[] | undefined;
	/** Driving events with locations and durations for display on the map. */
	events?: MapEventDto[] | undefined;
}

/** DTO representing trip metrics. */
export interface TripMetricsDto {
	/** Maximum speed in miles per hour. */
	maxSpeedMph?: number;
	/** Average speed in miles per hour. */
	averageSpeedMph?: number;
	/** Minutes of night driving. */
	nightDrivingMinutes?: number | undefined;
	/** Miles driven on motorways. */
	motorwayMiles?: number | undefined;
	/** Miles driven in urban areas. */
	urbanMiles?: number | undefined;
	/** Miles driven in rural areas. */
	ruralMiles?: number | undefined;
}

/** DTO representing trip risk scores with customer-facing descriptions. */
export interface TripRiskScoresDto {
	/** Overall trip score (-10 to 10). */
	totalScore?: number | undefined;
	/** Customer-facing description of the overall trip performance. */
	totalScoreDescription?: string | undefined;
	/** Speed score (-10 to 10). */
	speedScore?: number | undefined;
	/** Customer-facing description of the speed score. */
	speedScoreDescription?: string | undefined;
	/** Smooth driving score (-10 to 10). */
	smoothScore?: number | undefined;
	/** Customer-facing description of the smooth driving score. */
	smoothScoreDescription?: string | undefined;
	/** Usage score (-10 to 10). */
	useScore?: number | undefined;
	/** Customer-facing description of the usage score. */
	useScoreDescription?: string | undefined;
}

/** DTO representing a trip summary for the paged list view. */
export interface TripSummaryDto {
	/** Unique identifier for the trip. */
	tripId?: string;
	/** Trip start time in UTC. */
	startTimeUtc?: Date;
	/** Trip end time in UTC. */
	endTimeUtc?: Date;
	/** Total distance traveled in miles. */
	distanceMiles?: number;
	/** Duration of the trip in seconds. */
	durationSeconds?: number;
	/** Start address of the trip. */
	startAddress?: string | undefined;
	/** End address of the trip. */
	endAddress?: string | undefined;
	/** Overall trip score (-10 to 10). */
	totalScore?: number | undefined;
	/** Total number of events during the trip. */
	totalEventCount?: number;
	/** Encoded polyline representing the trip route using Google's Polyline Algorithm format. Decode client-side to render on a map. */
	polyline?: string | undefined;
}

/** Represents a paginated list of items. */
export interface TripSummaryDtoPaginatedList {
	/** Gets the items in the current page. */
	items?: TripSummaryDto[] | undefined;
	/** Gets the current page number (1-based). */
	pageNumber?: number;
	/** Gets the page size. */
	pageSize?: number;
	/** Gets the total number of items across all pages. */
	totalCount?: number;
	/** Gets the total number of pages. */
	readonly totalPages?: number;
	/** Gets whether there is a previous page. */
	readonly hasPreviousPage?: boolean;
	/** Gets whether there is a next page. */
	readonly hasNextPage?: boolean;
}

export class ApiException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isApiException = true;

	static isApiException(obj: any): obj is ApiException {
		return obj.isApiException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
